import { Link } from "react-router-dom";
import {
  ADDRESS,
  BUSINESS_HOURS,
  EMAIL,
  GOOGLE_MAPS_LINK,
  INSTAGRAM_HANDLE,
  INSTAGRAM_LINK,
  LOGO_URL,
  PHONE_DISPLAY,
  PHONE_TEL,
  TRIPADVISOR_LINK,
  WEBSITE_DISPLAY,
  WEBSITE_LINK,
  WHATSAPP_LINK,
} from "@/pages/home/constants";

export default function Footer() {
  return (
    <footer id="rodape" className="relative bg-primary-900 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8 py-7 md:py-10">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-6">
            <div>
              <div className="mb-3">
                <img
                  src={LOGO_URL}
                  alt="Eco Tour Turismo — Passeios de Lancha em Capitólio"
                  title="Eco Tour Turismo Capitólio"
                  className="h-16 w-auto object-contain"
                />
              </div>
              <p className="text-[11px] text-white/50 leading-relaxed max-w-xs">
                Especialistas em passeios de lancha e experiências náuticas em Capitólio, no coração do Mar
                de Minas. Conforto, segurança e atendimento personalizado.
              </p>
              <div className="flex items-center gap-2 mt-4">
                <a
                  href={WHATSAPP_LINK}
                  data-whatsapp-cta
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-accent-500 hover:text-primary-950 transition-all duration-200 cursor-pointer"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line text-xs" />
                </a>
                <a
                  href={INSTAGRAM_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-accent-500 hover:text-primary-950 transition-all duration-200 cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-xs" />
                </a>
                <a
                  href={GOOGLE_MAPS_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-accent-500 hover:text-primary-950 transition-all duration-200 cursor-pointer"
                  aria-label="Google Maps"
                >
                  <i className="ri-map-pin-2-line text-xs" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-xs font-semibold text-white/70 uppercase tracking-wider mb-3">
                <a href="#embarque" className="hover:text-accent-300 transition-colors cursor-pointer">
                  Onde Estamos
                </a>
              </h4>
              <div className="space-y-2 text-[11px] text-white/50">
                <p className="flex items-start gap-1.5">
                  <i className="ri-map-pin-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <a
                    href={GOOGLE_MAPS_LINK}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {ADDRESS}
                  </a>
                </p>
                <p className="flex items-start gap-1.5">
                  <i className="ri-phone-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <a href={`tel:${PHONE_TEL}`} className="hover:text-accent-300 transition-colors cursor-pointer">
                    {PHONE_DISPLAY}
                  </a>
                </p>
                <p className="flex items-start gap-1.5">
                  <i className="ri-mail-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <a href={`mailto:${EMAIL}`} className="hover:text-accent-300 transition-colors cursor-pointer break-all">
                    {EMAIL}
                  </a>
                </p>
                <p className="flex items-start gap-1.5">
                  <i className="ri-time-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <span>{BUSINESS_HOURS}</span>
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-xs font-semibold text-white/70 uppercase tracking-wider mb-3">
                Links Úteis
              </h4>
              <div className="space-y-2 text-[11px]">
                <a
                  href="#passeio-de-lancha"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Passeios de Lancha em Capitólio
                </a>
                <a
                  href="#roteiros"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Roteiros e Atrações em Capitólio
                </a>
                <a
                  href="#nossas-lanchas"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Nossa Frota de Lanchas
                </a>
                <a
                  href="#jet-ski"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Passeio de Jet Ski em Capitólio
                </a>
                <a
                  href={INSTAGRAM_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Instagram {INSTAGRAM_HANDLE}
                </a>
                <a
                  href={TRIPADVISOR_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Avaliações no Tripadvisor
                </a>
                <a
                  href={WEBSITE_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  {WEBSITE_DISPLAY}
                </a>
                <Link
                  to="/politica-de-privacidade"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Política de Privacidade
                </Link>
                <Link
                  to="/termos-de-uso"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Termos de Uso
                </Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-[10px] text-white/40 text-center sm:text-left">
              © 2026 Eco Tour Turismo Capitólio — Todos os direitos reservados.
            </p>
            <p className="text-[10px] text-white/40 text-center sm:text-right">
              Capitólio · MG — Mar de Minas
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}